module.exports = __webpack_public_path__ + "img/qr-code-with-icon.f0096a07.png";